/*
 * Copyright (c) 2005-2024, Paycheck Planner
 * All rights reserved
 * 
 */

import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';

import { useAuth, useDispatcher } from "../../components/AuthProvider"

import { MM } from "../../engine/model_manager";

import EditMilestonePane from "./EditMilestonePane";



export default function AddMilestone(props) {
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const results = useAuth();

  let sim_model = results.simResults.simModel;

  const model = results.currentModel.model;
  let model_milestone = MM.createMilestone(model);


  function handleSubmit(action) {
    dispatch(action);
    navigate(-1);
  }

  function handleCancel() {
    navigate(-1);
  }

  
  return (
    <>
      <h4>Add Milestone</h4>
      <EditMilestonePane action='addMilestone' simModel={sim_model} modelMilestone={model_milestone} onSubmit={handleSubmit} onCancel={handleCancel} />
    </>
  );

}

